
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Meta } from '@storybook/addon-docs';
import tokens from '../compiled/tokens/js/tokens.js';
const _ = require('lodash');
const opacities = tokens.number.opacity;
const opacityRows = Object.keys(opacities).map((key) => {
  const { name, attributes, value } = opacities[key];
  return (
    <tr key={name}>
      <td>opacity.${_.kebabCase(attributes.item)}</td>
      <td>
        <code>{value}</code>
      </td>
    </tr>
  );
});


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Design/Tokens/Opacity" mdxType="Meta" />
    <h1>{`Opacity`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-scss"
      }}>{`@use '../../compiled/tokens/scss/opacity';
$example: opacity.$muted; // => 0.65
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import tokens from '../../compiled/tokens/js/tokens';
console.log(tokens.number.opacity.muted.value); // => 0.65
`}</code></pre>
    <h2>{`Opacity`}</h2>
    <table>
  <thead>
    <tr>
      <th style={{
            width: '10%'
          }}>Name</th>
      <th>Value</th>
    </tr>
  </thead>
  <tbody>{opacityRows}</tbody>
    </table>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const __page = () => { throw new Error("Docs-only story"); };

__page.parameters = { docsOnly: true };

const componentMeta = { title: 'Design/Tokens/Opacity', includeStories: ["__page"],  };

const mdxStoryNameToKey = {};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;